export default {
  routerList: [

    {
      path: '/index',
      redirect: '/homePage'
    },
    {
      path: '/homePage',
      component: () => import('@/views/index/home/homePage.vue'),
      name: '主页',
      children: []
    },
    {
      path: '/newList',
      component: () => import('@/views/index/home/newList.vue'),
      name: '新闻列表',
      children: []
    },
    {
      path: '/newDetails',
      component: () => import('@/views/index/home/newDetails.vue'),
      name: '新闻详情',
      children: []
    },
    {
      path: '/overview',
      component: () => import('@/views/index/home/overview.vue'),
      name: '人大概览',
      children: []
    },
    {
      path: '/information',
      component: () => import('@/views/index/home/information.vue'),
      name: '人大资料',
      children: []
    },
    {
      path: '/specialSubject',
      component: () => import('@/views/index/home/specialSubject.vue'),
      name: '专题集锦',
      children: []
    },
    {
      path: '/magazine',
      component: () => import('@/views/index/home/magazine.vue'),
      name: '人大杂志',
      children: []
    },
    {
      path: '/delegation',
      component: () => import('@/views/index/home/delegation.vue'),
      name: '代表团',
      children: []
    },
    {
      path: '/representative',
      component: () => import('@/views/index/home/representative.vue'),
      name: '代表',
      children: []
    },
    {
      path: '/search',
      component: () => import('@/views/index/home/search.vue'),
      name: '搜索（首页）',
      children: []
    },
    {
      path: '/jgsz',
      component: () => import('@/views/index/home/jgsz.vue'),
      name: '机构设置',
      children: []
    },
    {
      path: '/jgszItem',
      component: () => import('@/views/index/home/jgszItem.vue'),
      name: '机构详情',
      children: []
    },
    {
      path: '/lettersVisits',
      component: () => import('@/views/index/home/lettersVisits.vue'),
      name: '信访',
      children: []
    },
    {
      path: '/lettersVisitsDetails',
      component: () => import('@/views/index/home/lettersVisitsDetails.vue'),
      name: '信访详情',
      children: []
    }

  ]
}
